import { getCookie } from '@/websdk/utils/common';

const languages = ['en-US', 'zh-CN', 'zh-TW'];

function getLang() {
  let lang = localStorage.lang || 'zh-CN';

  if (languages.includes(getCookie('lang'))) {
    lang = getCookie('lang');
  } else if (languages.includes(navigator.languages[0])) {
    lang = navigator.languages[0];
  }

  return lang;
}

const lang = getLang();

export default lang;
